// extracted by mini-css-extract-plugin
module.exports =  {"notification":"notification--W2FMy","danger":"danger--M46gH","container":"container--iclKV","wide":"wide--Wyidx"};